import { isSortOrder, type SortOrder } from '@/shared/lib';

/** The only ordering field the record settings endpoints accept. */
export const SETTINGS_SORT_FIELD = 'createdAt';

export type SettingsSortField = typeof SETTINGS_SORT_FIELD;

export interface SettingsListQuery {
  term?: string;
  sort?: SettingsSortField;
  order?: SortOrder;
}

export const isSettingsSortField = (value: string): value is SettingsSortField =>
  value === SETTINGS_SORT_FIELD;

/** `order` without `sort` is a 400, so the direction only travels with the field it applies to. */
export function buildSettingsListQuery(
  term: string,
  sort: string,
  order: string
): SettingsListQuery {
  const trimmedTerm = term.trim();
  const sortField = isSettingsSortField(sort) ? sort : undefined;

  return {
    ...(trimmedTerm ? { term: trimmedTerm } : {}),
    ...(sortField ? { sort: sortField, order: isSortOrder(order) ? order : 'desc' } : {}),
  };
}

export const settingsListQuerySignature = (query: SettingsListQuery): string =>
  [query.term ?? '', query.sort ?? '', query.order ?? ''].join('|');
